import React, { useEffect, useState } from 'react';
import { AppState, Platform } from 'react-native';
import Config from 'react-native-config';
import { useSelector } from 'react-redux';
import { environmentSelector } from '../redux/appSlice';
import { maintenanceStore } from './maintenanceStore';
import { maintenanceUrlFor } from './maintenanceState';
import { MaintenanceBannerView, MaintenanceScreenView } from './MaintenanceView';
const RETRY_MS = 30_000;
/**
 * Checks the flag on launch, on foreground and (via abbiWayApi) after failed
 * requests; retries quietly every 30 s while on. Native shows a full-screen view
 * over the app (no sign-out; the app resumes where it was). Web/admin shows a
 * banner, since reads keep working and only saving is paused.
 */
export function MaintenanceGate() {
    const environment = useSelector(environmentSelector);
    const [info, setInfo] = useState(maintenanceStore.get());
    useEffect(() => maintenanceStore.subscribe(setInfo), []);
    useEffect(() => {
        maintenanceStore.setUrl(maintenanceUrlFor(environment, Config.MAINTENANCE_URL));
        maintenanceStore.check({ force: true }).catch(() => undefined);
    }, [environment]);
    useEffect(() => {
        const sub = AppState.addEventListener('change', state => {
            if (state === 'active') {
                maintenanceStore.check().catch(() => undefined);
            }
        });
        return () => sub.remove();
    }, []);
    useEffect(() => {
        if (!info.enabled) {
            return;
        }
        const timer = setInterval(() => maintenanceStore.check({ force: true }).catch(() => undefined), RETRY_MS);
        return () => clearInterval(timer);
    }, [info.enabled]);
    if (!info.enabled) {
        return null;
    }
    return Platform.OS === 'web' ? (<MaintenanceBannerView info={info}/>) : (<MaintenanceScreenView info={info}/>);
}
export default MaintenanceGate;
